import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const LabelStyled = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'bgColor'
})(({ bgColor }) => ({
  padding: '4px 12px',
  borderRadius: '16px',
  border: 'none',
  backgroundColor: bgColor,
  width: 'fit-content'
}));
